import { ReactNode } from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui/box';

/**
 * Wrapping modal content in a focusable view prevents Chrome from automatically focusing
 * behavior in the Chrome browser.
 *
 */
export const FocusableContainer: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  return (
    <Box focusable style={styles.container}>
      {children}
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'transparent',
    flex: 1,
    justifyContent: 'center',
    outlineWidth: 0,
  },
});
